import React from 'react';
import {observer} from 'mobx-react';
import {ListItemViewModel} from "../../../../../infrastructure/models/list-item.view-model";
import {ACTION_TYPES} from "../../../../../core/consts";
import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import {MatchEventsModuleTabViewModel} from "../models/match-events-module.tab-view-model";
import {MatchEventsModuleController} from "../match-events-module.controller";
import {SecondaryTabs} from "../../../../../core/components/secondary-tabs/components/secondary-tabs";
import classNames from "classnames";
import styles from "../styles/match-event.module.scss";

export class MatchEventsTabsProps extends BaseProps {
  initialIndex: Number;
  tabs: Array<MatchEventsModuleTabViewModel>;
  controller: MatchEventsModuleController;
}

export const MatchEventsModuleTabs = observer(({controller}: MatchEventsTabsProps) => {
  const {state} = controller;
  const {tabs, activeTab, showTabs} = state;

  const tabsProps = {
    onChange: (e, tab: ListItemViewModel) => controller.action(ACTION_TYPES.tabChange, {index: tab.index}),
    initialIndex: activeTab?.index,
    tabs,
  }

  return (
    showTabs ? <div className={classNames(styles.tabs)}>
      <SecondaryTabs {...tabsProps}/>
    </div> : null
  )
});
